module.exports = __webpack_public_path__ + "img/20.7d6afeb8.jpg";